import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Routing } from 'shared/constants/routing';
import { IApplicationState } from 'store/state/app-state';
import images from 'assets/images';
import { ButtonBase, Popover, Avatar } from '@material-ui/core';
import { anchorOrigin, transformOrigin } from 'shared/constants/custom-styles';
import { logout } from 'store/actions/auth-actions';
import Notification from './Notification';
import Settings from './Settings';
import subscribeDeviceService from 'services/subscribe-device/subscribe-device-service';
import VerifiedIcon from '@mui/icons-material/Verified';
import { BRAND_TITLE } from 'shared/constants/constants';

const Header: React.FC = () => {
    const userData = useSelector((state: IApplicationState) => state.UserData);
    const dispatch = useDispatch();

    const [anchorEl, setAnchorEl] = React.useState(null);

    React.useEffect(() => {
        window.addEventListener('resize', resizeWin);
    }, []);

    const handleLogout = async () => {
        await subscribeDeviceService.subscribeDeviceDelete(userData.userIdEnc);
        dispatch(await logout());
    };

    const toggleMenu = () => {
        document.body.classList.toggle('show-menu');
        document.querySelector('.hamburger').classList.toggle('is-active');
    };

    const handlePopoverProfileClick = (event) => setAnchorEl(event.currentTarget);
    const handlePopoverProfileClose = () => setAnchorEl(null);

    const resizeWin = () => {
        if (document.getElementById('hamburger') != null) {
            document.body.classList.remove('show-menu');
            document.getElementById('hamburger').classList.remove('is-active');
        }
    };

    return (
        <header className="header">
            <div className="left-header">
                <div className="hamburger" id="hamburger" onClick={toggleMenu}>
                    <span className="line"></span>
                    <span className="line"></span>
                    <span className="line"></span>
                </div>

                <Link to={Routing.TimeLine} title={BRAND_TITLE} className="logo">
                    <img src={images.Logo} alt="Logo" />
                </Link>
            </div>
            <div className="right-header">
                <ul className="right-menu-header">
                    <li>
                        <Notification />
                    </li>
                    <li>
                        <Settings />
                    </li>
                    <li className="profile-wrapper">
                        <ButtonBase>
                            <a href="#" title="Profile" className="profile-block" onClick={handlePopoverProfileClick}>
                                <em className="dp">
                                    <Avatar alt="Profile Pic" src={userData?.profilePhoto} />
                                    {userData?.isSubscribed && <VerifiedIcon className="verified-ic" />}
                                </em>
                                <span className="username">{userData?.username}</span>
                            </a>
                        </ButtonBase>

                        <Popover
                            className="profile-popover"
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handlePopoverProfileClose}
                            anchorOrigin={anchorOrigin}
                            transformOrigin={transformOrigin}
                        >
                            <ul>
                                <li onClick={handlePopoverProfileClose}>
                                    <Link to={Routing.MyProfile} title="My Profile">
                                        <em>
                                            <img src={images.icUser} alt="My Profile" />
                                        </em>
                                        My Profile
                                    </Link>
                                </li>
                                {/* <li>
                                    <a href="#" title="Help">
                                        <em>
                                            <img src={images.helpIc} alt="Help" />
                                        </em>
                                        Help
                                    </a>
                                </li> */}
                                <li>
                                    <a href="#" onClick={handleLogout} title="Logout">
                                        <em>
                                            <img src={images.logoutIc} alt="Logout" />
                                        </em>
                                        Logout
                                    </a>
                                </li>
                            </ul>
                        </Popover>
                    </li>
                </ul>
            </div>
        </header>
    );
};

export default Header;
